import { render, staticRenderFns } from "./setingwu.vue?vue&type=template&id=04348aa6&scoped=true&"
import script from "./setingwu.vue?vue&type=script&lang=js&"
export * from "./setingwu.vue?vue&type=script&lang=js&"
import style0 from "./setingwu.vue?vue&type=style&index=0&id=04348aa6&lang=scss&scoped=true&"
import style1 from "./setingwu.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04348aa6",
  null
  
)

export default component.exports